import {
  CurrentDeviceClientSurface,
  CurrentDeviceDisplayPrivacyMode,
  type CurrentDeviceContextSnapshot,
} from '@automatick/shared-ts';
import { Injectable } from '@angular/core';

const webCurrentDeviceContextSnapshot: CurrentDeviceContextSnapshot =
  Object.freeze({
    clientSurface: CurrentDeviceClientSurface.WebControl,
    physicalDeviceId: null,
    nodeId: null,
    surfaceSessionId: null,
    displayPrivacyMode: CurrentDeviceDisplayPrivacyMode.Private,
    canDisplaySensitiveContent: false,
  });

@Injectable({ providedIn: 'root' })
export class CurrentDeviceContextService {
  snapshot(): CurrentDeviceContextSnapshot {
    return webCurrentDeviceContextSnapshot;
  }
}
